import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../features/auth/login.service';

@Injectable({
  providedIn: 'root',
})
export class TicketsService {
  constructor(private http: HttpClient) {}
  baseUrl: string = environment.baseUrl;

  getAllTickets(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/getalltickets`, payload);
  }

  getCurrentMonthTickets(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/getcurrentmonthticket`, payload);
  }

  createTicket(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/createticket`, payload);
  }

  createMultipleTickets(payload: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/createmultipleticket`, payload);
  }

  reserveTickets(ticketIds: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/reservetickets`, { ticketIds });
  }

  unreserveTickets(ticketIds: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/unreservetickets`, { ticketIds });
  }

  updateTicket(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/updateticket`, payload);
  }

  deleteTicket(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/ticket/deleteticket`, { id });
  }
}
